module.exports = __webpack_public_path__ + "static/media/4.24fad1ad.jpg";